export default "__VITE_ASSET__Dug5SYVY__"